import {processDynamicColumns, setFieldVisibility, setSectionCollapsed} from "../../../../../apps/KpModule/actions"
import {generateFetchFieldListAction, GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api"
import _ from "lodash";
import {fieldsVisibilityRules} from "../utils"
import { ObjectId } from 'bson'
import {otherActivityFormField, refreshOtherActivityField, relabelOtherActivityOption} from "../../utils/otherActivity"
import {hasOtherActivity} from "../../staticEntities"

const ADHESION_SHELTER_TYPES_LIST = "m-C-file.AdhesionShelter_types"

// statuses in which the association fills in the administrative section
const ADMINISTRATIVE_SECTION_STATUSES = ['preValidated', 'incomplete2']

export const module_ = {
    object: 'Adhesion',
    name: 'File',
    tKey: 'mTitle_adhesionFile',
    newable: false,
    removable: false,
    objectIdentifier: 'mail',
    formSections: [
        {
            id: 'institutionalSection',
            tKey: 'Volet Institutionnel',
            defaultCollapsed: false,
        },
        {
            id: 'administrativeSection',
            tKey: 'Volet Administratif',
            defaultCollapsed: true,
        },
        {
            id: 'sanitarySection',
            tKey: 'Volet Sanitaire',
            defaultCollapsed: true,
        },
    ],
    category: {
        path: 'menuTitle_adhesion',
        icon: 'idCard'
    },
    viewMap: {
        dt: [
            {path: 'applicationNumber', tKey: "Référence"},
            {path: 'fullName', tKey: 'chairperson'},
            {path: 'mail', width: 250},
            {path: 'phone', tKey: "mobilePhone"},
            {path: 'organizationName', tKey: "tradingName"},
            {path: 'organizationZipCode', tKey: 'zipCode', initiallyNotVisible: true},
            {path: 'organizationCity', tKey: 'city', initiallyNotVisible: true},
            {path: 'code', tKey: 'N° SIREN'},
            {path: 'status', type: "status", fieldPath: ['id', 'name', 'bStyle'], width: 450},
            {path: 'createdAt', initiallyNotVisible: true}
        ],
        form: {
            fields: [
                {path: 'applicationNumber', tKey: "Référence", disabled: true},
                {path: 'userSection', section: "institutionalSection", data: "Président(e) de l'association", type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}},
                {path: 'civility', tKey: 'title', section: "institutionalSection", required: true},
                {path: 'firstname', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", required: true},
                {path: 'lastname', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", required: true},
                {path: 'mail', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", disabled: true, required: true, emailAddress: true, lowercase: true},
                {path: 'phone', tKey: 'mobilePhone', type: 'phoneNumber', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", required: true},

                {path: 'organizationSection', section: "institutionalSection", data: 'Association', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {path: 'organizationName', tKey: 'tradingName', section: "institutionalSection", required: true},
                {path: 'code', tKey: 'N° SIREN', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", exactLength: 9, required: true},
                {path: 'publicUtilityRecognition', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", required: true},
                {path: 'organizationAddress', tKey: 'address', section: "institutionalSection", disabled: true, required: true},
                {path: 'organizationAdditionalAddress', tKey: 'additionalAddress', section: "institutionalSection"},
                {path: 'organizationZipCode', tKey: 'zipCode', section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", exactLength: 5, required: true},
                {path: 'organizationCity', tKey: 'city', section: "institutionalSection", disabled: true, widthClassName: "col-xs-12 col-sm-6", required: true},
                {path: 'organizationCountry', tKey: 'country', section: "institutionalSection", hidden: true},
                {path: "sheltersNumber", tKey: "Nombre d'établissements (refuges)", section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", required: true, wholePositiveNumber: true, minValue: 0, maxValue: 10},
                {path: "animalTypeGroup", tKey: "Groupe d’espèces pris en charge", section: "institutionalSection", widthClassName: "col-xs-12 col-sm-6", required: true},

                {path: 'documentsSection', section: "institutionalSection", data: 'Documents institutionnels', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {path: 'contactID', tKey: "Pièce d'identité Président(e) de l'association", fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "institutionalSection", required: true},
                {path: 'situationNotice', tKey: 'associationStatusNotice', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "institutionalSection", required: true},
                {path: 'updatedStatus', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "institutionalSection", required: true},
                {path: 'balanceSheetsAndIncomeStatements', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "institutionalSection", required: true},
                {path: 'officialStatement', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "institutionalSection", required: true},
                {path: 'CERFA', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "institutionalSection", required: true},
                {path: 'DDPVisitReports', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "institutionalSection"},
                {path: 'lastGeneralMeeting', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "institutionalSection", required: true},

                {path: 'structureSection', section: "administrativeSection", data: "Structure de l'association", type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {path: 'employeesNumber', section: "administrativeSection", tKey: 'employeesNumber_2', widthClassName: "col-xs-12 col-sm-6", wholePositiveNumber: true, required: true},
                {path: 'electedOfficialsNumber', section: "administrativeSection", tKey: 'electedOfficialsNumber_2', widthClassName: "col-xs-12 col-sm-6", wholePositiveNumber: true, required: true},
                {path: 'volunteersNumber', section: "administrativeSection", tKey: 'volunteersNumber_2', widthClassName: "col-xs-12 col-sm-6", wholePositiveNumber: true, required: true},
                {path: 'investigatorsNumber', section: "administrativeSection", tKey: 'investigatorsNumber_2', widthClassName: "col-xs-12 col-sm-6", wholePositiveNumber: true, required: true},

                {path: 'activitiesSection', section: "administrativeSection", data: "Activités de l'association", type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {
                    path: 'types', tKey: 'Activités de l’association', placeholder: 'Sélectionner les activités', section: "administrativeSection", required: true,
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, module}) => {
                            const statusId = _.get(store.getState(), 'edit.object.data.status.id')
                            refreshOtherActivityField({store, module}, 'types', ADMINISTRATIVE_SECTION_STATUSES.includes(statusId))
                            const otherActivity = module.viewMap.form.fields.find(field => field.path === 'otherActivity')?.getValue()
                            store.dispatch(generateFetchFieldListAction(
                                ADHESION_SHELTER_TYPES_LIST,
                                store.getState,
                                {data: {types: newValue}}
                            )).then(() => relabelOtherActivityOption(store, ADHESION_SHELTER_TYPES_LIST, otherActivity))
                        }
                    },
                },
                otherActivityFormField({
                    section: "administrativeSection",
                    subscriptions: {
                        onChange: (newValue, oldValue, {store}) => relabelOtherActivityOption(store, ADHESION_SHELTER_TYPES_LIST, newValue)
                    }
                }),

                {
                    path: 'animalTypes',
                    section: 'administrativeSection',
                    tKey: 'animalTypes_2',
                    filters: ['byAnimalTypeGroup'],
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, module}) => {

                            store.dispatch(generateFetchFieldListAction(
                                "m-C-file.AdhesionShelter_animalTypes",
                                store.getState,
                                {data: {animalTypes: newValue}}
                            ))

                            const animalTypeCapacityField = module.viewMap.form.fields.find(field => field.path === 'adhesionCapacityByAnimalTypeConfigs')
                            const animalTypeCapacityFieldValue = animalTypeCapacityField.getValue()
                            const previousValues = animalTypeCapacityFieldValue?.[0]?.numberByAnimalType
                            const animalTypeCapacityFieldNewValue = [{
                                animalType: 'number',
                                numberByAnimalType: newValue ? newValue.reduce((acc, animalType) => ({
                                    ...acc,
                                    [animalType.name]: previousValues?.[animalType.name] || 0
                                }), {}) : {}
                            }]

                            animalTypeCapacityField.setValue(animalTypeCapacityFieldNewValue)
                            store.dispatch(processDynamicColumns({adhesionCapacityByAnimalTypeConfigs: animalTypeCapacityFieldNewValue}))
                        }
                    }
                },

                {path: 'acacedCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},

                {
                    path: 'adhesionCapacityByAnimalTypeConfigs',
                    tKey: 'adhesionCapacityByAnimalType',
                    type: 'dtObjects',
                    required: true,
                    section: 'administrativeSection',
                    fields: [
                        {path: 'animalType', translate: true},
                        {path: 'numberByAnimalType', type: 'editText', inputType: 'number', dynamic: true, required: true}
                    ]
                },

                {path: 'sheltersSection', section: "administrativeSection", data: "Établissement(s) de l'association", type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {
                    path: 'adhesionShelters',
                    section: "administrativeSection",
                    tKey: "Coordonnées",
                    viewMap: {
                        dt: [
                            {path: 'code', tKey: 'siret_spec'},
                            {path: 'status', tKey: 'status'},
                            {path: 'name'},
                            {path: 'zipCode', tKey: 'zipCode_spec'},
                            {path: 'city', tKey: 'city_spec', initiallyNotVisible: true},
                        ],
                        form: [
                            {path: 'code', tKey: 'siret_spec', required: true, placeholder: 'Renseigner le SIRET', exactLength: 14, numerical: true, widthClassName: "col-xs-12 col-sm-6"},
                            {path: 'status', tKey: 'status', widthClassName: "col-xs-12 col-sm-6", placeholder: 'Sélectionner le statut', default: {id: 'headquarters', name: 'Siège'}},
                            {path: 'name', required: true, placeholder: 'Renseigner le nom'},
                            {
                                path: 'types',
                                tKey: 'activities_spec',
                                placeholder: 'Sélectionner les activités',
                                filters: ['byTypes'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const shelterField = module.viewMap.form.fields.find(f => f.path === 'adhesionShelters')
                                        const capacityField = shelterField.viewMap.form.fields.find(f => f.path === 'adhesionCapacityByActivity')
                                        const currentRows = capacityField.getValue() || []

                                        const updatedRows = currentRows.map(row => {
                                            const previousCapacityByActivity = row.capacityByActivity || {}
                                            return {
                                                ...row,
                                                capacityByActivity: newValue ? newValue.reduce((acc, type) => ({
                                                    ...acc,
                                                    [type.id]: previousCapacityByActivity[type.id] || 0
                                                }), {}) : {}
                                            }
                                        })

                                        capacityField.setValue(updatedRows)
                                        store.dispatch(processDynamicColumns({adhesionCapacityByActivity: updatedRows}))
                                    }
                                }
                            },
                            {
                                path: 'animalTypes',
                                tKey: 'species',
                                placeholder: 'Sélectionner les espèces',
                                display: 'name',
                                filters: ['byAnimalTypes'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const shelterField = module.viewMap.form.fields.find(f => f.path === 'adhesionShelters')
                                        const typesField = shelterField.viewMap.form.fields.find(f => f.path === 'types')
                                        const currentTypes = typesField.getValue()

                                        const capacityField = shelterField.viewMap.form.fields.find(f => f.path === 'adhesionCapacityByActivity')
                                        const currentRows = capacityField.getValue() || []

                                        const updatedRows = newValue ? newValue.map(animalType => {
                                            const existingRow = currentRows.find(row => row.animalType?.id === animalType.id)
                                            const previousCapacityByActivity = existingRow?.capacityByActivity || {}
                                            return {
                                                id: existingRow?.id || new ObjectId().toString(),
                                                animalType,
                                                ddpp: existingRow?.ddpp || 0,
                                                totalCapacity: existingRow?.totalCapacity || 0,
                                                capacityByActivity: currentTypes ? currentTypes.reduce((acc, type) => ({
                                                    ...acc,
                                                    [type.id]: previousCapacityByActivity[type.id] || 0
                                                }), {}) : previousCapacityByActivity
                                            }
                                        }) : []

                                        capacityField.setValue(updatedRows)
                                        store.dispatch(processDynamicColumns({adhesionCapacityByActivity: updatedRows}))
                                    }
                                }
                            },
                            {
                                path: 'adhesionCapacityByActivity',
                                tKey: 'Chiffres produits lors de la dernière assemblée générale',
                                type: 'dtObjects',
                                fields: [
                                    {path: 'animalType', display: 'name', translate: true},
                                    {path: 'ddpp', tKey: 'Capacité agréée DDPP', type: 'editText', inputType: 'number', width: 100},
                                    {path: 'totalCapacity', tKey: 'Capacité réelle', type: 'editText', inputType: 'number', width: 100},
                                    {path: 'capacityByActivity', type: 'editText', inputType: 'number', dynamic: true}
                                ]
                            },
                            {path: 'address', tKey: 'address_spec', required: true, placeholder: "Renseigner l'adresse"},
                            {path: 'additionalAddress', tKey: 'additionalAddress_spec', placeholder: "Renseigner le complément d'adresse"},
                            {path: 'zipCode', tKey: 'zipCode_spec', widthClassName: "col-xs-12 col-sm-6", required: true, placeholder: 'Renseigner le code postal', maxLength: 5, noSpaces: true, numerical: true},
                            {path: 'city', tKey: 'city_spec', widthClassName: "col-xs-12 col-sm-6", required: true, placeholder: 'Renseigner la ville'},
                            {path: 'shelterSchedules', type: 'textarea'},
                            {path: 'country', tKey: 'country_spec', default: 'France', hidden: true, disabled: true, required: true},
                        ]
                    }
                },

                {path: 'documentsSection2', section: "administrativeSection", data: 'Documents administratifs', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                {path: 'bnoDeclarationReceipt', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'nonCarnivoreSpeciesActivityDeclaration', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'adoptionContractAndCommitmentCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'hostFamilyContract', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'animalEntryExitRegisterExtract', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'icpeDeclarationDogs', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection"},
                {path: 'dogWalkSchedule', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},

                {path: 'cerfa15045Receipt', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},

                {path: 'breedingRegister', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'animalHoldingLocationDeclaration', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'commitmentAndKnowledgeCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'animalWelfareOfficerDeclaration', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},

                {path: 'gdsFarmSummarySheet', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},

                {path: 'openingAuthorizationPrefecture', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'animalHandlingCapacityCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},
                {path: 'transportAuthorization', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "administrativeSection", required: true},

                {path: 'documentsSection3', section: "sanitarySection", data: 'Documents sanitaires', type: 'heading', hideLabel: true, style: {margin: '15px 5px 0', fontSize: 'larger', color: 'rgb(255 152 0)', padding: '10px 0'}, disabled: true},

                { path: 'healthRegulationFile', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "sanitarySection", required: true },
                { path: 'veterinarySanitaryDeclaration', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "sanitarySection", required: true },
                { path: 'veterinaryAdoptionCertificate', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "sanitarySection", required: true },
                { path: 'lastVeterinaryVisitReport', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "sanitarySection", required: true },
                { path: 'healthMonitoringRegisterExtract', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "sanitarySection", required: true },
                { path: 'selfInspectionStrategy', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "sanitarySection", required: true },
                { path: 'lastIfceInspectionReport', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "sanitarySection", required: true },
                { path: 'prophylaxisOrDdppExemptionReport', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: "simpleFiles", section: "sanitarySection", required: true },

                //{path: 'documents', section: "administrativeSection", tKey: 'Documents divers'},

                {path: 'status', hidden: true},
                {path: 'conversations', hidden: true},
                {path: 'buttons', hidden: true}
            ]
        }
    },
    filters: ['byUser'],
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store, module }) => {
                const state = store.getState()

                const statusId = _.get(state, 'edit.object.data.status.id')
                const animalTypeGroupId = _.get(state, 'edit.object.data.animalTypeGroup.id')
                const hasShelters = !!_.get(state, 'edit.object.data.sheltersNumber')

                const applicationNumberField = module.viewMap.form.fields.find(field => field.path === "applicationNumber")

                store.dispatch(generateFetchFieldListAction(
                    "m-C-file.Adhesion_animalTypes",
                    store.getState,
                    {data: {animalTypeGroup: {id: animalTypeGroupId}}}
                ))

                const handledFields = new Set()

                // Section visibility based on status
                const visibleSections = new Set()
                const sectionStatusMap = {
                    institutionalSection: ['incomplete'],
                    administrativeSection: ADMINISTRATIVE_SECTION_STATUSES,
                    sanitarySection: ['validated2', 'incomplete3']
                }
                Object.entries(sectionStatusMap).forEach(([section, statuses]) => {
                    if (statuses.includes(statusId)) visibleSections.add(section)
                })

                store.dispatch(setFieldVisibility(applicationNumberField.id, true))
                handledFields.add(applicationNumberField.id)

                const setVisible = (fieldId, section, condition) => {
                    const visible = visibleSections.has(section) && condition
                    store.dispatch(setFieldVisibility(fieldId, visible))
                    handledFields.add(fieldId)
                }

                // Section collapse rules
                store.dispatch(setSectionCollapsed('institutionalSection', statusId !== 'incomplete'))
                store.dispatch(setSectionCollapsed('administrativeSection', !ADMINISTRATIVE_SECTION_STATUSES.includes(statusId)))
                store.dispatch(setSectionCollapsed('sanitarySection', !['validated2', 'incomplete3'].includes(statusId)))

                // Apply field-specific visibility rules
                const fileRules = fieldsVisibilityRules(animalTypeGroupId, hasShelters, hasOtherActivity(_.get(state, 'edit.object.data.types')));
                fileRules.forEach(({ id, section, condition }) => {
                    setVisible(id, section, condition)
                })

                // Fallback: section-wide visibility for other fields
                module.viewMap.form.fields.forEach(field => {
                    if (!handledFields.has(field.id)) {
                        const show = visibleSections.has(field.section)
                        store.dispatch(setFieldVisibility(field.id, show))
                    }
                })
            }
        }
    ],
}
